<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-02-21 09:21:41
 * @LastEditors: mrh
 * @LastEditTime: 2021-01-13 16:14:12
-->
<template>
  <div class="content">
    <h5-header :header-msg="headerMsg"></h5-header>
    <router-link tag="div" to="/roles" class="common">
      <span>选菜妈妈用户协议</span>
      <i class="iconfont icon-home_location_icon_r"></i>
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headerMsg: {
        title: "关于我们",
        url: ""
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = "#F5F5F5";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#FFFFFF";
    next();
  }
};
</script>

<style lang="scss" scoped>
.content {
  .common {
    width: auto;
    height: 60px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 400;
    color: #1d1d1d;
    background-color: #ffffff;
  }
}
</style>